module.exports = __webpack_public_path__ + "img/health-badge.7de4f166.png";